// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "assets/css/" + chunkId + "." + {"2":"2dc73ead","254":"5cdd0532","348":"8c7107d6","365":"e9aab951","516":"3fa227c3","540":"dae3b639","624":"8d8339d1","635":"f9143ac9","704":"e9b860cd","762":"1d580a56","890":"54f8ceec","891":"1ad6cb01","895":"8474b7da"}[chunkId] + ".css";
};